import React, { useState, useCallback, useEffect } from "react";
import {
  Card,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import dialogBgImage from "assets/images/dialogBgImage.png";
import { useMediaQuery } from "react-responsive";
import { IconButton, InputAdornment } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { reportPost } from "services/apiService";

function ReportDialog({ openStatus, onClose, postId }) {
  let navigate = useNavigate();

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const reportTypes = [
    "It's a spam",
    "Violence or Dangerous organisations",
    "Nudity or sexual acitivity",
    "Bullying or harassment",
    "Scam or fraud",
    "Suicide or self injury",
    "Something else",
  ];

  const handleReportPost = async (reportMsg) => {
    const reportData = {
      message: reportMsg,
      postID: postId,
    };

    const reportPostRes = await reportPost(reportData);
    // console.log("reportPostRes", reportPostRes);
    onClose();

    if (reportPostRes.status === 200) {
      Swal.fire({
        title: "Thank you reporting",
        text: "We will review and take the necessary action against this.",
        icon: "success",
        background: "darkgray",
        width: "360px",
        // confirmButtonText: "Remove",
        // confirmButtonColor: "red",
        // showCancelButton: true,
      });
    } else {
      toast.error(`Something went wrong, Please try again`, {
        style: {
          fontSize: "15px",
        },
      });
    }
  };

  return (
    <Dialog
      sx={{}}
      open={openStatus}
      maxWidth="sm"
      fullWidth
      fullScreen={isTabletOrMobile && true}
      onClose={onClose}
    >
      <MDBox
        sx={{
          border: isDesktopOrLaptop && "1px solid #F2CB2E",
          borderRadius: isDesktopOrLaptop && "8px",
          backgroundColor: "#1a1a1a",
          // backgroundImage: `url(${dialogBgImage})`,
          // backgroundRepeat: "no-repeat",
          // backgroundSize: "cover",
          // objectFit: "cover",
        }}
      >
        <DialogTitle sx={{}}>
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MDTypography>Report Post</MDTypography>

            <IconButton onClick={onClose}>
              <MDTypography>
                <CloseIcon />
              </MDTypography>
            </IconButton>
          </MDBox>
        </DialogTitle>
        <DialogContent sx={{ flexDirection: "column" }}>
          {/* <MDButton color="singh" variant="outlined" fullWidth>
            It's a spam
          </MDButton>
          <MDButton color="singh" variant="outlined" fullWidth>
            Violence or Dangerous organisations
          </MDButton>
          <MDButton color="singh" variant="text" fullWidth>
            Nudity or sexual activity
          </MDButton>
          <MDButton color="singh" variant="text" fullWidth>
            Bullying or harassment
          </MDButton>
          <MDButton color="singh" variant="text" fullWidth>
            Scam or fraud
          </MDButton>
          <MDButton color="singh" variant="text" fullWidth>
            Suicide or self injury
          </MDButton>
          <MDButton color="singh" variant="text" fullWidth>
            Something else
          </MDButton> */}
          {reportTypes.map((item, idx) => (
            <MDButton
              color="singh"
              variant="outlined"
              fullWidth
              key={idx}
              sx={{ marginBottom: "1rem" }}
              onClick={() => handleReportPost(item)}
            >
              {item}
            </MDButton>
          ))}
        </DialogContent>
      </MDBox>
    </Dialog>
  );
}

export default ReportDialog;
